// Import components.
import Captcha from './components/Captcha.jsx';

/**
 * <pre>
 * Captcha module React Components.
 *
 * Summary of responsibilities:
 *
 *  - defines React components that this app module can render
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Captcha
 * @namespace
 *
 * @type {Object}
 */
const Components = {
	Captcha: Captcha
};

export default Components;